module.exports = __webpack_public_path__ + "media/images/social-share-button/delicious-3b1585bfa2c68e3d2c0dc678a5456a51.svg";